import React, { Fragment } from "react";
import { useEffect, useState } from "react";
import HistoriesContent from "../../components/account/HistoriesContent";
import MoneyDetailsContent from "../../components/account/MoneyDetailsContent";
import ChangeUserPwd from "../../components/account/ChangeUserPwd";
import ChangeUserInfo from "../../components/account/ChangeUserInfo";

import NavLink from "react-router-dom/NavLink";
import { Route, Switch } from "react-router-dom";
import PointDetailsContent from "../../components/account/PointDetailsContent";
import PointHistoryContent from "../../components/account/PointHistoryContent";
import Headbar from "../../components/Layout/Headbar";
import { isEmpty } from "../../common/cores";
import { isMobile } from "../../utils/utils";
import { MobileFootbar } from "../../components/Layout/Footbar";
import MobileStickyFootbar from "../../components/Layout/MobileStickyFootbar";
const MyPage = (props) => {
  const { match } = props;
  //   console.log(props)
  return (
    <Fragment>
      <div id="layoutBody" style={{ paddingTop: "0px" }}>
        <div className="wrapper  lang_ko" id="bodyTemplate">
          <div id="contentTheme"></div>
          <Headbar />
          <div
            className="title_wrap"
            style={{ paddingTop: isMobile() && "10px" }}
          >
            <div className="title_box">
              <div className="title">
                {isEmpty(window.lang["마이페이지"])
                  ? "마이페이지"
                  : window.lang["마이페이지"]}
              </div>
            </div>
          </div>
          <div className="mypage_cont">
            <div className="contents_box">
              <div className="con_box00">
                <div className="tab_wrap">
                  <ul>
                    <NavLink
                      className="tab"
                      activeClassName="tabon"
                      to={`${match.url}/history`}
                    >
                      {isEmpty(window.lang["베팅내역"])
                        ? "베팅내역"
                        : window.lang["베팅내역"]}
                    </NavLink>
                    <NavLink
                      className="tab"
                      activeClassName="tabon"
                      to={`${match.url}/depositHistory`}
                    >
                      {isEmpty(window.lang["입금"])
                        ? "입금"
                        : window.lang["입금"]}
                      /
                      {isEmpty(window.lang["출금내역"])
                        ? "출금내역"
                        : window.lang["출금내역"]}
                    </NavLink>
                    <NavLink
                      className="tab"
                      activeClassName="tabon"
                      to={`${match.url}/pointExchangeHistory`}
                    >
                      {isEmpty(window.lang["포인트전환 내역"])
                        ? "포인트전환 내역"
                        : window.lang["포인트전환 내역"]}
                    </NavLink>
                    <NavLink
                      className="tab"
                      activeClassName="tabon"
                      to={`${match.url}/pointHistory`}
                    >
                      {isEmpty(window.lang["포인트내역"])
                        ? "포인트내역"
                        : window.lang["포인트내역"]}
                    </NavLink>
                    <NavLink
                      className="tab"
                      activeClassName="tabon"
                      to={`${match.url}/setting`}
                    >
                      {isEmpty(window.lang["비밀번호수정"])
                        ? "비밀번호수정"
                        : window.lang["비밀번호수정"]}
                    </NavLink>
                    <NavLink
                      className="tab"
                      activeClassName="tabon"
                      to={`${match.url}/userinfo_setting`}
                    >
                      {isEmpty(window.lang["회원정보 변경"])
                        ? "회원정보 변경"
                        : window.lang["회원정보 변경"]}
                    </NavLink>
                  </ul>
                </div>
              </div>
              <Switch>
                <Route
                  path={`${match.url}/history`}
                  component={HistoriesContent}
                />
                <Route
                  path={`${match.url}/depositHistory`}
                  component={MoneyDetailsContent}
                />
                <Route
                  path={`${match.url}/pointExchangeHistory`}
                  component={PointDetailsContent}
                />
                <Route
                  path={`${match.url}/pointHistory`}
                  component={PointHistoryContent}
                />
                <Route
                  path={`${match.url}/setting`}
                  component={ChangeUserPwd}
                />
                <Route
                  path={`${match.url}/userinfo_setting`}
                  component={ChangeUserInfo}
                />
              </Switch>
            </div>
          </div>
        </div>
      </div>
      {isMobile() && <MobileStickyFootbar />}
    </Fragment>
  );
};

export default MyPage;



// WEBPACK FOOTER //
// ./src/containers/Account/MyPage.js